import { jsx as i } from "react/jsx-runtime";
import _ from "clsx";
import '../../../_assets/Container.67bzv6t8.css';const m = "_container_dfq7b_44", d = "_container_narrow_dfq7b_75", n = {
  container: m,
  container_narrow: d
}, f = (r) => {
  const { as: o = "div", className: t, children: a, narrow: c, id: e, ...s } = r;
  return /* @__PURE__ */ i(
    o,
    {
      ...s,
      className: _(t, c ? n.container_narrow : n.container),
      id: e,
      children: a
    }
  );
};
export {
  f as Container
};
